import { Image } from 'antd';

const LogoWithBG = (props) => {
  const { backgroundImg, logoImg, altBg, altLogo, ...rest } = props;
  return (
    <div
      className="relative w-[250px] h-[250px] bg-cover bg-center m-4"
      style={{ backgroundImage: `url(${backgroundImg})`}}
      {...rest}
    >
      <div className="absolute inset-0 flex items-center justify-center w-[180px] mx-auto">
        <Image
          src={logoImg}
          preview={false}
          alt={altLogo}
          className="w-full h-auto"
        />
      </div>
    </div>
  );
}

export default LogoWithBG;
